export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-screen w-full bg-night-blue overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.readdy.ai/image/e52027607460cffc32b49812e98784ba/8cedbdc4cc3a7f945c0fd475fd86e321.png"
          alt="Alunos da TL Artes & Música tocando instrumentos com iluminação cinematográfica"
          title="TL Artes & Música - Escola de Música Cristã em Ribeirão Preto"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-night-blue/70 via-night-blue/50 to-night-blue/85 z-[1]"></div>

      <div className="relative z-10 w-full min-h-screen flex flex-col justify-center">
        <div className="w-full px-6 md:px-12 lg:px-16">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-0">
            <div className="w-full lg:w-1/2 flex flex-col items-start gap-8 pt-24 lg:pt-0">
              <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-[1.12] tracking-tight max-w-[600px]">
                Louvai ao Senhor<br />em todo o tempo.
              </h1>

              <p className="font-sans text-base md:text-lg text-white/85 leading-relaxed max-w-[500px]">
                A escola de música onde a excelência técnica encontra o propósito espiritual. Do zero ao avançado, desenvolva o seu talento em um ambiente projetado para honrar a Deus e moldar verdadeiros adoradores.
              </p>

              <div className="flex flex-col sm:flex-row items-start gap-3 md:gap-4 pt-4">
                <a
                  href="#cursos"
                  className="group inline-flex items-center gap-2 md:gap-3 bg-vibrant-blue hover:bg-vibrant-blue/90 text-white font-sans font-medium text-xs md:text-sm tracking-wide uppercase px-5 md:px-8 py-3 md:py-4 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Iniciar Minha Jornada Musical
                  <span className="w-6 h-6 flex items-center justify-center border border-white/40 rounded-sm group-hover:translate-x-0.5 transition-transform">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </a>

                <a
                  href="#como-funciona"
                  className="inline-flex items-center gap-2 border border-white/30 hover:border-white/60 text-white font-sans font-medium text-xs md:text-sm tracking-wide uppercase px-5 md:px-8 py-3 md:py-4 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  NoSSO método
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-12 pb-8 md:absolute md:bottom-10 md:left-1/2 md:-translate-x-1/2 md:mt-0 md:pb-0 z-10">
          <a href="#filosofia" className="flex flex-col items-center gap-2 text-white/50 hover:text-white/80 transition-colors cursor-pointer">
            <span className="font-sans text-[11px] tracking-[0.25em] uppercase">Dê o primeiro passo</span>
            <i className="ri-arrow-down-line text-lg animate-bounce"></i>
          </a>
        </div>
      </div>
    </section>
  );
}